import posthog from 'posthog-js'
import { useEffect, useState } from 'react'

/**
 * React hook for PostHog feature flags
 * Returns the current value of a feature flag
 *
 * @param flagKey - The feature flag key
 * @param defaultValue - Default value if flag is not available (default: false)
 * @returns Current feature flag value
 */
export function useFeatureFlag(flagKey: string, defaultValue: boolean = false): boolean {
  const [isEnabled, setIsEnabled] = useState(defaultValue)

  useEffect(() => {
    const value = posthog.isFeatureEnabled(flagKey)
    setIsEnabled(value ?? defaultValue)

    posthog.onFeatureFlags(() => {
      const updatedValue = posthog.isFeatureEnabled(flagKey)
      setIsEnabled(updatedValue ?? defaultValue)
    })
  }, [flagKey, defaultValue])

  return isEnabled
}
